import React, { Component } from 'react'
import { withAlert } from 'react-alert'
import { connect } from 'react-redux'

import successSvg from '../static/graphics/alerts/success.svg'
import infoSvg from '../static/graphics/alerts/info.svg'
import errorSvg from '../static/graphics/alerts/error.svg'

// Alert options
export const AlertOptions = {
    timeout: 4000,
    position: 'top right',
    transition: 'fade',
}

function alertType(optionType) {
    switch (optionType) {
        case 'info':
            return 'primary'
        case 'success':
            return 'success'
        case 'error':
            return 'danger'
        default:
            return 'primary'
    }
}

function getSvg(optionType) {
    switch (optionType) {
        case 'info':
            return infoSvg
        case 'success':
            return successSvg
        case 'error':
            return errorSvg
        default:
            return infoSvg
    }
}

export const AlertTemplate = ({ style, options, message, close }) => (
    <div
        className={`alert alert-dismissible alert-${alertType(
            options.type
        )} py-0`}
        style={style}>
        <img
            className="m-2"
            src={getSvg(options.type)}
            alt={options.type}
            width="25px"
        />
        {message}
        <button type="button" className="close" data-dismiss="alert">
            &times;
        </button>
    </div>
)

export class Alerts extends Component {
    componentDidUpdate(prevProps) {
        const { alert_message, alert } = this.props

        if (alert_message !== prevProps.alert_message) {
            alert.show(alert_message.message, { type: alert_message.type })
        }
    }

    render() {
        return <></>
    }
}

const mapStateToProps = (state) => ({
    alert_message: state.alerts.alert_message,
})

export default connect(mapStateToProps)(withAlert()(Alerts))
